import React from 'react';

import { IconSwitcher } from '@src/components/Icon';
import NotificationCrossIcon from '@src/components/Icon/NotificationCrossIcon';
import NotificationTickIcon from '@src/components/Icon/NotificationTickIcon';
import { H4 } from '@src/components/Typography';
import { useNewThemeActive, themeStyle } from '@src/theming';
import { transientProps } from '@src/utils/transientProps';

import { ToastTypes } from './store/types';
import { StyledDefaultToast, StyledLightPopoverToast } from './styles';
import { ToastProps } from './types';

export const Toast: React.FC<ToastProps> = ({
  type,
  children,
  small,
  error,
  theme = {},
  transitionStatus,
}) => {
  const isNewThemeActive = useNewThemeActive();
  const icon = error ? NotificationCrossIcon : NotificationTickIcon;

  if (type === ToastTypes.LIGHT_POPOVER) {
    return (
      <StyledLightPopoverToast
        {...transientProps(theme)}
        $transitionStatus={transitionStatus}
      >
        <H4>{children}</H4>
      </StyledLightPopoverToast>
    );
  }

  const errorColor = isNewThemeActive
    ? themeStyle.redMedium
    : theme?.errorIconColor;

  const successColor = isNewThemeActive
    ? themeStyle.greenMain
    : theme?.iconColor;

  return (
    <StyledDefaultToast
      {...transientProps(theme)}
      $transitionStatus={transitionStatus}
      className="hide-in-e2e"
    >
      {!small ? (
        <IconSwitcher
          height="100%"
          icon={icon}
          theme={{
            color: error ? errorColor : successColor,
            secondaryColor: theme?.secondaryIconColor,
          }}
        />
      ) : (
        <span style={{ paddingLeft: '5px' }} />
      )}
      <H4 color={theme?.color}>{children}</H4>
    </StyledDefaultToast>
  );
};
